import React, { useEffect } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { withProfiler } from "@sentry/react";
import LandingLayout from "layouts/LandingLayout";
import SuperAdminLayout from "layouts/SuperAdminLayout";
import Adminlayout from "layouts/AdminLayout";
import AuthLayout from "layouts/AuthLayout";
import ProtectedRoutes from "routes/ProtectedRoutes";
import PublicRoutes from "routes/PublicRoutes";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <ProtectedRoutes path="/super-admin" component={SuperAdminLayout} />
        <ProtectedRoutes path="/admin" component={Adminlayout} />
        <PublicRoutes path="/auth" component={AuthLayout} />
        <PublicRoutes path="/" component={LandingLayout} />
      </Switch>
    </BrowserRouter>
  );
}

export default withProfiler(App);
